import React, { createContext, useContext } from 'react';

import { VariableInfo } from '@/lib/App';

export interface VariableContextType {
  variable: VariableInfo;
}

const VariableContext = createContext<VariableContextType | undefined>(
  undefined,
);

export const useVariable = () => {
  const context = useContext(VariableContext);
  if (!context) {
    throw new Error('useVariable must be used within a VariableProvider');
  }
  return context.variable;
};

export const VariableProvider: React.FC<{
  variable: VariableInfo;
  children: React.ReactNode;
}> = ({ variable, children }) => {
  const value: VariableContextType = {
    variable,
  };

  return (
    <VariableContext.Provider value={value}>
      {children}
    </VariableContext.Provider>
  );
};

export default VariableContext;
